import React from 'react';
import UserList from './UserList';
import VinList from './VinList';
import { CeDealershipV1, DealershipUserV1, DealershipVehicleV1 } from '../../services/dealerships/types';
import OwnerCard from './OwnerCard';
import DealershipInfo from './DealershipInfo';

interface DealershipCompProps {
  dealerships: CeDealershipV1[] | undefined;
  onUserSelect: (user: DealershipUserV1) => void;
  onDealershipClick: (dealership: CeDealershipV1) => void;
  onOwnerSelect: (user: DealershipUserV1, id: string) => void;
  onUserClickDelete: (user: DealershipUserV1, dealership: CeDealershipV1) => void;
  onVehicleClickDelete: (user: DealershipVehicleV1, dealership: CeDealershipV1) => void;
}

const Dealership: React.FC<DealershipCompProps> = ({
  dealerships,
  onUserSelect,
  onDealershipClick,
  onOwnerSelect,
  onUserClickDelete,
  onVehicleClickDelete,
}) => {
  if (!dealerships) {
    return <div />;
  }
  const handleDealershipClick = (dealership: DealershipUserV1) => {
    if (onDealershipClick) {
      onDealershipClick(dealership); // Notify parent
    }
  };
  const handleOwnerSelect = (user: DealershipUserV1, id: string) => {
    if (onOwnerSelect) {
      onOwnerSelect(user, id); // Notify parent
    }
  };
  const handleUserSelect = (user: DealershipUserV1) => {
    if (onUserSelect) {
      onUserSelect(user); // Notify parent
    }
  };
  const handleUserClickDelete = (user: DealershipUserV1, dealership: CeDealershipV1) => {
    if (onUserClickDelete) {
      onUserClickDelete(user, dealership); // Notify parent
    }
  };
  const handleVinClickDelete = (vehicle: DealershipVehicleV1, dealership: CeDealershipV1) => {
    if (onVehicleClickDelete) {
      onVehicleClickDelete(vehicle, dealership); // Notify parent
    }
  };
  return (
    <div>
      <DealershipInfo onDealershipClick={handleDealershipClick} dealership={dealerships.at(0) ?? {}} />
      <OwnerCard dealership={dealerships.at(0)} onOwnerSelect={handleOwnerSelect} />
      <UserList
        dealership={dealerships.at(0)}
        onUserSelect={handleUserSelect}
        onUserClickDelete={handleUserClickDelete}
      />
      <VinList
        dealership={dealerships.at(0)}
        vehicles={dealerships.at(0)?.vehicles}
        onVinClickDelete={handleVinClickDelete}
      />
    </div>
  );
};

export default Dealership;
